import AuthActions from 'reducers/Auth/authSlice'
import { resetIdentifyUser } from './segmentService'
import { asyncDispatch } from './storeHelpers'

const INVALID_SESSION_STATUSES = [401, 403]

let forcedLogoutInProgress = false

export const hasPersistedSession = () =>
  Boolean(
    window.localStorage.getItem('accessToken') ||
      window.localStorage.getItem('refreshToken')
  )

export const clearPersistedSession = () => {
  window.localStorage.removeItem('refreshToken')
  window.localStorage.removeItem('accessToken')
}

export const resetSessionState = async (dispatch) => {
  clearPersistedSession()
  resetIdentifyUser()

  const action = AuthActions.logout()

  if (dispatch) {
    dispatch(action)
    return action
  }

  return asyncDispatch(action)
}

export const isSessionInvalidResponse = (error) => {
  const status = error?.status || error?.response?.status

  return INVALID_SESSION_STATUSES.includes(status)
}

export const forceLogout = async (dispatch) => {
  if (forcedLogoutInProgress) {
    return false
  }

  forcedLogoutInProgress = true

  try {
    await resetSessionState(dispatch)
    return true
  } finally {
    forcedLogoutInProgress = false
  }
}
